import { createContext, useContext } from 'react';
import { useFeature } from '~/modules/root';

/**
 * Whether a section is drawn on the revamped homepage. The revamp sets its
 * desktop type below the banner at 75% of the shared sections' sizes, on a
 * warm ground with a warmer grey; the detail, directory and product pages that
 * reuse those sections keep their own sizes, so the shared components read
 * this instead of changing for everyone. False everywhere while `revamp_2026`
 * is off, so the homepage keeps its previous design.
 *
 * Kept apart from `HomePageScope` so the components every page renders (the
 * site footer's subscribe field) can read it without pulling the Magic Island
 * into every page's bundle.
 */
export const HomePageScopeContext = createContext(false);

/**
 * True only inside the revamped homepage's `HomePageScope`. Shared components
 * key their homepage restyle off this, never off the flag, so the pages that
 * reuse them stay as they are when `revamp_2026` turns on.
 */
export const useIsHomePage = () => useContext(HomePageScopeContext);

/**
 * Whether the homepage draws its `revamp_2026` design. For choosing between a
 * homepage section's two designs; a component that other pages also render
 * reads `useIsHomePage` instead.
 */
export const useHomePageRevamp = () => useFeature('revamp_2026');
